<template>
	<p class="d-flex justify-content-center align-items-center my-5">
		{{ this.$root?.translate(this.title) }}
	</p>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
	name: "VPlaceholder",
	props: {
		title: {
			type: String,
			default: 'placeholder-title',
		},
	},
});
</script>

<style scoped>
</style>
